import { createActionsStructure } from 'services/reduxHelpers'

/* ------------- Action Creators ------------- */

export const { dateTypes, dateActions } = createActionsStructure('date', [
  { name: 'SELECT_DATE', async: false },
  { name: 'SELECT_RANGE_DATE', async: false }
])



// WEBPACK FOOTER //
// ./src/reduxModules/actions/DateActions.js